<div class="page-container">

  <!-- Header -->
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon">calendar_month</mat-icon>
      <div>
        <div class="page-title">Holidays</div>
        <div class="page-subtitle">{{ subtitle }}</div>
      </div>
    </div>
  </div>

  <!-- Form card -->
  <div class="form-card mat-elevation-z2">
    <form [formGroup]="form" (ngSubmit)="onSave()" novalidate>

      <!-- Radio toggle: Specific date / Configure date -->
      <div class="radio-group-row">
        <mat-radio-group formControlName="type" class="radio-group" aria-label="Holiday type">
          <mat-radio-button value="specific" class="radio-btn">
            Specific date
          </mat-radio-button>
          <mat-radio-button value="configured" class="radio-btn">
            Configure date
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="form-fields">

        <!-- Holiday name (always shown) -->
        <mat-form-field appearance="outline" class="field-full">
          <mat-label>Holiday name</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="e.g. Veterans Day"
            autocomplete="off"
            aria-required="true"
          />
          <mat-error *ngIf="form.get('name')?.hasError('required')">
            Holiday name is required
          </mat-error>
        </mat-form-field>

        <!-- SPECIFIC DATE fields -->
        <ng-container *ngIf="isSpecific">
          <mat-form-field appearance="outline" class="field-medium">
            <mat-label>Holiday date</mat-label>
            <input
              matInput
              [matDatepicker]="datePicker"
              formControlName="date"
              placeholder="MM/DD/YYYY"
              aria-label="Holiday date"
            />
            <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>
        </ng-container>

        <!-- CONFIGURED DATE fields -->
        <ng-container *ngIf="isConfigured">
          <div class="configured-row">

            <!-- Ordinal: First / Second / Third / Fourth / Last -->
            <mat-form-field appearance="outline" class="field-sm">
              <mat-label>Ordinal month's day</mat-label>
              <mat-select formControlName="ordinal" aria-label="Ordinal">
                <mat-option *ngFor="let o of ordinals" [value]="o">{{ o }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Day of week -->
            <mat-form-field appearance="outline" class="field-sm">
              <mat-label>Day</mat-label>
              <mat-select formControlName="dayOfWeek" aria-label="Day of week">
                <mat-option *ngFor="let d of daysOfWeek" [value]="d">{{ d }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Month -->
            <mat-form-field appearance="outline" class="field-sm">
              <mat-label>Month</mat-label>
              <mat-select formControlName="month" aria-label="Month">
                <mat-option *ngFor="let m of months" [value]="m">{{ m }}</mat-option>
              </mat-select>
            </mat-form-field>

          </div>
        </ng-container>

      </div><!-- /form-fields -->

    </form>
  </div>

  <!-- Footer actions -->
  <div class="footer-actions">
    <button
      mat-stroked-button
      class="go-back-btn"
      type="button"
      (click)="goBack()"
      aria-label="Go back"
    >
      GO BACK
    </button>
    <button
      mat-flat-button
      color="primary"
      class="save-btn"
      type="submit"
      (click)="onSave()"
      aria-label="Save holiday"
    >
      SAVE
    </button>
  </div>

</div>
